import React from 'react';
import { PublicFeed } from '@src/layouts';
import { generateFilters, JobsList } from '@src/features/feed';
import { getJobs } from '@src/services/jobs';
import { EmployerNav } from './organisms';

const Page = function () {
  return (
    <PublicFeed
      store="jobsList"
      activeIndex={0}
      content={<JobsList {...{ getJobs }} />}
      generateFilters={generateFilters}
      header={<EmployerNav />}
      marginTop="75px"
    />
  );
};

export default Page;
